import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { getProblem } from "../../actions/problem";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

const ProblemDisplay = ({
  getProblem,
  problem: { problem, loading },
  match,
}) => {
  useEffect(() => {
    getProblem(match.params.id);
  }, [getProblem, match.params.id]);

  return loading || problem == null ? (
    <div className="problems1">
      <img
        src={require("../../images/load.gif")}
        alt="Loading . . . "
        className="load"
      />
    </div>
  ) : (
    <div className="problems">
      <div className="container-fluid">
        <div className="row">
          <div className="col-10 mx-auto">
            <div className="row">
              <div className="col-md-6 col-sm-12 mt-3 order-2 order-md-1">
                <h4>Problem Description</h4>
                <p style={{ fontSize: "20px" }}>
                  <span>Title: </span>
                  {problem.que_no}. {problem.title}
                </p>
                <div>
                  <p>{problem.description}</p>
                  <p>
                    <span>Difficulty: </span>
                    {problem.difficulty === "Easy" && (
                      <span style={{ color: "rgb(44, 99, 44)" }}>Easy</span>
                    )}
                    {problem.difficulty === "Medium" && (
                      <span style={{ color: "rgb(211, 150, 36)" }}>Medium</span>
                    )}
                    {problem.difficulty === "Hard" && (
                      <span style={{ color: "rgb(188, 34, 34)" }}>Hard</span>
                    )}
                  </p>
                  <p>
                    <span>Constraints: </span>
                    {problem.constraint}
                  </p>

                  <div>
                    <span>Input: </span>
                    {problem.example_input.split("\n").map((item, i) => (
                      <p key={i}>{item}</p>
                    ))}
                  </div>
                  <div>
                    <span>Output: </span>
                    {problem.example_output.split("\n").map((item, i) => (
                      <p key={i}>{item}</p>
                    ))}
                  </div>
                  <p>
                    <span>Time Limit: </span>
                    {problem.time_limit} Sec
                  </p>
                  <p>
                    <span>Memory Limit: </span>
                    {problem.memory_limit} KB
                  </p>

                  <Link
                    to={`/problems/${problem._id}/submit`}
                    style={{ color: "inherit" }}
                  >
                    <button className="gbtn mb-4">Submit a Solution</button>
                  </Link>
                </div>
              </div>
              <div className="col-md-6 col-sm-12 order-1 order-md-2">
                <img src={require("../problems/codewindow.png")} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ProblemDisplay.propTypes = {
  getProblem: PropTypes.func.isRequired,
  problem: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  problem: state.problem,
});

export default connect(mapStateToProps, { getProblem })(ProblemDisplay);
